<div class="" style="background-color: #132a42; ">
<div class="row p-5" style="background-color: #132a42; height: 100vh;">
    <div class="col-sm-12 w-100">
        <div class="d-flex justify-content-between   row w-100 m-0">

  
    <!--<img class="pt-3" style="display: block; margin-right: auto; margin-left: auto;  min-height: 8%; min-width: 8%;"  src="https://appointele.com/assets/logo2020w.png" />-->
    <img class="pt-3" style="display: block; margin-right: auto; margin-left: auto;  min-height: 8%; min-width: 8%;"  src="./assets/logo2020w.png" />

<div class="w-100 text-center">
    <h1 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>WELCOME </h1>
</div>

<div class="py-5" style="display: block; margin-right: auto; margin-left: auto; " >
    <h1 class="text-dark  my-5 p-3 bg-white" style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark " (click)="noAppointmentQuestionaire()" translate>CHECK IN</a></h1><!--routerLink="/have-appointment-question"-->
</div>
    </div>
</div>
</div>
</div>